var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBtnArrowRight = function SvgIconBtnArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0444 6.75L12.6889 10.95L13.7778 12L20 6L13.7778 0L12.6889 1.05L17.0444 5.25L0 5.25V6.75L17.0444 6.75Z",
    fill: "white"
  })));
};
export default SvgIconBtnArrowRight;